export default __webpack_public_path__ + "images/Imagen 3.b64e8b0fafd445340adf8de26a5d5387.png";